var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudyWithdrawal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.91669 0.666504C2.60704 0.666504 3.16669 1.22615 3.16669 1.9165V16.0832C3.16669 16.7735 2.60704 17.3332 1.91669 17.3332C1.22633 17.3332 0.666687 16.7735 0.666687 16.0832V1.9165C0.666687 1.22615 1.22633 0.666504 1.91669 0.666504ZM6.50011 1.49984C7.61123 1.49984 8.55647 1.82906 9.48383 2.19485L10.1783 2.47149C11.106 2.83729 11.5 3.1665 13.1667 3.1665C14.8334 3.1665 15.6667 2.33317 16.5 2.33317C17.0556 2.33317 17.3334 2.59136 17.3334 3.12454L17.3334 11.9165C17.3346 13.9965 12.75 13.9998 10.6667 12.7498C8.58335 11.4998 6.50002 12.3332 5.66669 12.3332C4.83335 12.3332 4.00002 11.9165 4.00002 10.6665V3.1665C4.00002 2.05539 4.83338 1.49984 6.50011 1.49984Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudyWithdrawal);
export default __webpack_public_path__ + "static/media/study-withdrawal.79d78fc3.svg";
export { ForwardRef as ReactComponent };